var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPricingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pricing_icon",
    transform: "translate(-0.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15595",
    "data-name": "Path 15595",
    d: "M0,0H21V9H0Z",
    transform: "translate(35.063 18.124)",
    fill: "#ffd5d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_330",
    "data-name": "Ellipse 330",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(13.112 24.09)",
    fill: "#c9f0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M53.263,66.2A34.853,34.853,0,0,1,12,11.67l-.95,4.927a1.615,1.615,0,1,0,3.168.634c1.362-6.812,2.012-10.155,2-10A1.584,1.584,0,0,0,14.627,5.38L4.489,5.618a1.584,1.584,0,0,0,0,3.169l6.035-.143A38.022,38.022,0,0,0,54.657,69.053,1.587,1.587,0,0,0,53.263,66.2Z",
    transform: "translate(0 3.143)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M64,64.116l-6.035.143C81.174,40.13,63.749,0,30.484,0A37.76,37.76,0,0,0,13.8,3.85a1.584,1.584,0,0,0-.745,2.123c1.584,3.026,4.752-2.8,17.425-2.8,29.876,0,46.1,35.6,25.979,58.064l.95-4.927a1.615,1.615,0,1,0-3.168-.634c-2.17,10.852-2.075,10.219-1.964,10.678.428,1.584,1.061,1.188,11.706.935A1.584,1.584,0,0,0,64,64.116Z",
    transform: "translate(7.493 0)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M50.582,10H33.157a3.96,3.96,0,0,0-3.96,3.961v3.058A17.427,17.427,0,1,0,30.48,50.1c1.584,1.473,1.172,1.093,20.1,1.093a3.96,3.96,0,0,0,3.96-3.961c0-5.371.174-5.83-.808-7.129,1.014-1.347.808-2,.808-7.129a4.009,4.009,0,0,0-.808-2.376,4.009,4.009,0,0,0,.808-2.376c0-5.371.174-5.83-.808-7.129,1.014-1.347.808-2,.808-7.129A3.976,3.976,0,0,0,50.582,10ZM32.365,13.961a.808.808,0,0,1,.792-.792H50.582c1.046,0,.792.84.792,5.545a.808.808,0,0,1-.792.792c-19.437,0-14.985.412-18.217-1.252Zm19.009,9.506v4.753a.808.808,0,0,1-.792.792H41.188a17.428,17.428,0,0,0-3.311-6.337H50.55a.808.808,0,0,1,.824.792Zm0,9.506v4.753a.808.808,0,0,1-.792.792H41.188a16.621,16.621,0,0,0,.681-6.337h8.712A.808.808,0,0,1,51.374,32.972Zm-41.186.792A14.257,14.257,0,1,1,24.445,48.023,14.258,14.258,0,0,1,10.188,33.764ZM51.374,47.231a.808.808,0,0,1-.792.792H34.424a17.617,17.617,0,0,0,5.528-6.337H50.582a.808.808,0,0,1,.792.792Z",
    transform: "translate(4.027 5.843)",
    fill: "#0faceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M282.726,75.108h-3.045a1.374,1.374,0,0,0-.938,2.365l7.6,7.192a1.361,1.361,0,1,0,1.876-1.971l-5.125-4.853a5.823,5.823,0,0,0,3.82-1.7,6.315,6.315,0,0,0,1.577-2.8h1.822a1.359,1.359,0,1,0,0-2.719H288.49a5.927,5.927,0,0,0-.788-1.9h2.61a1.359,1.359,0,1,0,0-2.719H279.681a1.359,1.359,0,0,0,0,2.719h3.045a3.249,3.249,0,0,1,2.9,1.9h-5.941a1.359,1.359,0,0,0,0,2.719h5.941A3.922,3.922,0,0,1,285,74.2,3.151,3.151,0,0,1,282.726,75.108Z",
    transform: "translate(-256.216 -35.735)",
    fill: "#0faceb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingIcon);
export default __webpack_public_path__ + "static/media/Pricing_icon.2f36298bb7e2d806eff50bfc5935ea53.svg";
export { ForwardRef as ReactComponent };